import { useQuery } from 'react-query';

import { useGlobalFilters } from '@ge/feat-analyze/hooks';
import { useFeaturePrefs } from '@ge/hooks/feature-prefs';
import {
  AnalyzeGlobalFilterKeys,
  DamagesTracker,
  QueryKey,
  ManageDefs,
} from '@ge/models/constants';
import { Config, useStaticData } from '@ge/shared/data-hooks';
import { AppScopes } from '@ge/shared/models/scopes';

import { fetchDamagesResultCount } from '../services/damages';

export const useDamagesCounts = ({ filterDate }) => {
  const { featPrefs } = useFeaturePrefs(AppScopes.MANAGE_DAMAGES);
  const globalFilters = useGlobalFilters();
  const { isLoaded } = useStaticData();
  let { endDate, startDate } = filterDate;
  const options = {};
  const status = 'Open';
  let damage;
  const DAMAGES_TRACKER = ManageDefs.DAMAGES_TRACKER;

  const damageTracker =
    featPrefs &&
    featPrefs[DAMAGES_TRACKER] &&
    featPrefs[DAMAGES_TRACKER]?.find((damageTracker) => damageTracker?.selected);

  if (damageTracker?.id === DamagesTracker.ALL_OPEN && damageTracker?.selected) {
    damage = 'All';
  } else if (damageTracker?.id === DamagesTracker.BLADES_OPEN && damageTracker?.selected) {
    damage = 'Blade';
  } else if (damageTracker?.id === DamagesTracker.ALL_CLOSED && damageTracker?.selected) {
    damage = 'AllClosed';
  } else if (damageTracker?.id === DamagesTracker.NON_BLADES_CATEGORY && damageTracker?.selected) {
    damage = 'nonBlade';
  }

  const {
    data: damagesResultCount,
    isFetching: isLoading,
    /* Please refer to the invalidateQueries documentation, 
    isLoading is true with no data initially,
    isFetching is true for all in-flight requests, including background updates, like invalidateQueries */
    isSuccess,
  } = useQuery(
    [QueryKey.DAMAGE_COUNTS, globalFilters, endDate, startDate, status, damage],
    () => fetchDamagesResultCount({ filters: globalFilters, endDate, startDate, status }, options),
    {
      ...Config.EXECUTE_ONCE,
      enabled: Boolean(isLoaded && globalFilters[AnalyzeGlobalFilterKeys.SITE_IDS]?.length),
      staleTime: 0,
      cacheTime: 0,
    },
  );

  return {
    isLoading,
    isSuccess,
    data: damagesResultCount,
    error: null,
  };
};
